import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from '../../../app/core/services/utility_functions/utility_functions.service';
import { ZuperDialogConfig } from './zuper-dialog.types';

@Component({
    selector     : 'zuper-dialog',
    templateUrl  : './zuper-dialog.component.html',
    styles       : [
        /* language=SCSS */
        `
                                                                                                                          .zuper-confirmation-dialog-panel {
                                                                                                                              @screen md {
                                                                                                                                  @apply w-128;
                                                                                                                              }
                                                                                                              
                                                                                                                              .mat-mdc-dialog-container {
                                                                                                                                  padding: 0 !important;
                                                                                                                              }
                                                                                                                          }
                                                                                                                      `
    ],
    encapsulation: ViewEncapsulation.None
})
export class ZuperDialogComponent implements OnInit
{
    localKeys: any = {};
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ZuperDialogConfig,
        public matDialogRef: MatDialogRef<ZuperDialogComponent>,
        private utilityService: UtilityService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {}

    get getCancelDisplayKey(): string{
        // eslint-disable-next-line max-len
        return this.data?.actions?.cancel?.cancelDisplayKey ? this.convertLocalKey(this.data?.actions?.cancel?.cancelDisplayKey)  ? this.convertLocalKey(this.data?.actions?.cancel?.cancelDisplayKey) : this.data?.actions?.cancel?.label :  this.data?.actions?.cancel?.label;
    }

    get getConfirmDisplayKey(): string{
        // eslint-disable-next-line max-len
        return this.data?.actions?.confirm?.confirmDisplayKey ? this.convertLocalKey(this.data?.actions?.confirm?.confirmDisplayKey) ? this.convertLocalKey(this.data?.actions?.confirm?.confirmDisplayKey) : this.data?.actions?.confirm?.label :  this.data?.actions?.confirm?.label;
    }

    convertLocalKey(key?: any): string{
        return this.utilityService.getLocaleValue(key);
    }

    get getConfirmButtonClass(): string{
        const colorCode =  {
            success : 'text-white bg-green-500',
            warning: 'text-white bg-amber-500',
            error:'text-white bg-red-600',
            primary:'text-white bg-primary',
            info: 'text-white bg-blue-500'
            };
        return colorCode[this.data?.actions?.confirm?.color];
    }

    get getNoteClass(): string{
        const colorCode =  {
            success : 'text-green-500',
            warning: 'text-amber-500',
            error:'text-red-600',
            primary:'text-primary',
            info: 'text-blue-500'
            };
        return colorCode[this.data?.type];
    }

    getIconClass(iconColour: any): string{
        let returnValue: string = '';
        switch (iconColour) {
            case 'primary':
                returnValue =  'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600';
                break;
            case 'accent':
                returnValue =  'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600';
                break;
            case 'warn':
                returnValue =  'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600';
                break;
            case 'basic':
                returnValue =  'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600';
                break;
            case 'info':
                returnValue =  'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600';
                break;
            case 'success':
                returnValue =  'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500';
                break;
            case 'warning':
                returnValue =  'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500';
                break;
            case 'error':
                returnValue =  'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600';
                break;
            default:
                returnValue =  'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600';
                break;
        }

        return returnValue;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

}
